/* Inglés: esta ficha usa su diccionario (el de la tienda + sus frases). mk-idioma.js (defer, en el pie) lo lee después de esto. */
if(window.MK3_DICT) window.MK_DICT_URL=window.MK3_DICT;
/* Monk · PDP v3. Los textos que cambian con el pack viven en el DOM y se alternan por CSS (body[data-pack]);
   aquí solo se cambia el atributo, los enlaces y las fechas. Nada queda oculto si este script falla. */
(function(){
  var root=document.getElementById('mk3'); if(!root) return;
  var $=function(s,c){return (c||document).querySelector(s)}, $$=function(s,c){return [].slice.call((c||document).querySelectorAll(s))};

  /* --- pack --- */
  var boton=$('#boton'), botones=[$('#boton2'),$('#boton3')].filter(Boolean);
  function setPack(p){
    document.body.setAttribute('data-pack',p);
    var href=boton.getAttribute('data-href'+p); boton.href=href; botones.forEach(function(b){b.href=href;});
  }
  $$('.m3-pack input',root).forEach(function(i){ i.addEventListener('change',function(){ if(i.checked) setPack(i.value); }); });


  /* --- carrito lateral con order bump, calco del tema borrador (v44): la casilla solo sale con 1 Monk
         y marcarla pasa al pack de 2 (mismo precio del pack). Se puede cambiar de pack en «¿Cuántos Monks?». --- */
  var cart=$('#cart');
  if(cart){
    var PRE={1:'54,95 €',2:'89 €',3:'119 €'}, TACH={1:'',2:'109,90 €',3:'164,85 €'};
    var chk=$('#cartBumpChk'), viaBump=false, n=2;
    function pon(k,desdeBump){
      n=k; viaBump=(k===2&&desdeBump);
      $('#cartBump').hidden=!(k===1||viaBump); chk.checked=viaBump;
      $('#cartPre').textContent=PRE[k]; $('#cartTot').textContent=PRE[k]; $('#cartTach').textContent=TACH[k];
      $$('.m3-cpk',cart).forEach(function(b){ b.classList.toggle('on',+b.getAttribute('data-n')===k); });
      $('#cartPago').href=boton.getAttribute('data-href'+k);
    }
    chk.addEventListener('change',function(){ pon(chk.checked?2:1,true); });
    $$('.m3-cpk',cart).forEach(function(b){ b.addEventListener('click',function(){ pon(+b.getAttribute('data-n')); }); });
    var abreCart=function(e){
      var p=+(document.body.getAttribute('data-pack')||2); if(!PRE[p]) return;
      e.preventDefault(); pon(p); cart.hidden=false; document.body.style.overflow='hidden'; $('.m3-cart__x').focus();
    };
    [boton].concat(botones).forEach(function(b){ b.addEventListener('click',abreCart); });
    var cierraCart=function(){ cart.hidden=true; document.body.style.overflow=''; };
    $$('[data-cerrar]',cart).forEach(function(b){ b.addEventListener('click',cierraCart); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!cart.hidden) cierraCart(); });
  }

  /* --- entrega y urgencia: los pedidos salen de lunes a viernes hasta las 17:00 y llegan en 2 días laborables --- */
  /* Idioma (15 oct): el selector ES/EN de la tienda (mk-idioma.js) traduce con un diccionario y deja
     congelado lo que cambia solo. Lo que este script escribe lleva data-mk-partido (mk-idioma no lo toca)
     y se pinta aquí en los dos idiomas. Los bloques fijos con números vivos traen su inglés en data-en. */
  var EN=function(){ return /^en/i.test(document.documentElement.lang||''); };
  var DIAS=['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  var DAYS=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var CORTE=17;
  function laborable(d){ return d.getDay()!==0&&d.getDay()!==6; }
  function salida(ahora){ /* día y hora límite en que sale el pedido */
    var d=new Date(ahora); d.setHours(CORTE,0,0,0);
    if(!(laborable(ahora)&&ahora<d)){ do{ d.setDate(d.getDate()+1); }while(!laborable(d)); }
    return d;
  }
  function entrega(sale){ var d=new Date(sale), n=0; while(n<2){ d.setDate(d.getDate()+1); if(laborable(d)) n++; } return d; }
  function pintaFechas(){
    var en=EN(), ahora=new Date(), sale=salida(ahora), d=entrega(sale), corto=(en?DAYS:DIAS)[d.getDay()]+' '+d.getDate();
    $$('.fecha').forEach(function(e){e.textContent=corto;});
    $$('.m3-llega').forEach(function(e){ var h=(en?'Arrives ':'Llega el ')+'<span class="fecha-corta">'+corto+'</span>'; if(e.innerHTML!==h) e.innerHTML=h; });
    var t=$('#urgeTxt'); if(!t) return;
    var ms=sale-ahora, h=Math.floor(ms/36e5), m=Math.floor(ms%36e5/6e4), hoy=sale.toDateString()===ahora.toDateString(), html;
    if(ms<24*36e5){
      html=en ? 'Order in the next <span class="m3-reloj">'+(h?h+' h ':'')+m+' min</span>'+(hoy?' and it ships today':'')+'. Arrives <b>'+corto+'</b>.'
              : 'Pídelo en las próximas <span class="m3-reloj">'+(h?h+' h ':'')+m+' min</span>'+(hoy?' y sale hoy':'')+'. Lo recibes el <b>'+corto+'</b>.';
    } else {
      html=en ? 'Ships on '+DAYS[sale.getDay()]+' and arrives <b>'+corto+'</b>.'
              : 'Sale el '+DIAS[sale.getDay()]+' y lo recibes el <b>'+corto+'</b>.';
    }
    if(t.innerHTML!==html) t.innerHTML=html;
  }
  pintaFechas(); setInterval(pintaFechas,30000);

  function radio(p){ var r=$('.m3-pack input[value="'+p+'"]',root); if(r){ r.checked=true; setPack(p); } }

  /* --- ¿Qué te pasa a ti con el móvil? Banco de situaciones (assets/situaciones.js) --- */
  var B=window.MONK_SIT, q=$('#sitQ');
  if(B&&q){
    var cats=$('#sitCats'), chips=$('#sitChips'), sug=$('#sitSug'), catAct=B.cats[0][0], actual=null;
    var norm=function(t){return (t||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');};
    var app=function(k){ var a=B.apps[k]; return a[0]?'<li><img src="assets/img/monk-ico-'+a[0]+'.svg" alt="" width="30" height="30"><span>'+a[1]+'</span></li>':'<li class="m3-sit__txt"><span>'+a[1]+'</span></li>'; };
    function avisa(id,texto){ /* para saber qué problemas trae la gente: dataLayer, píxel de Meta y eventos de Shopify si existen */
      try{ (window.dataLayer=window.dataLayer||[]).push({event:'monk_situacion',situacion:id,texto:texto||''}); }catch(e){}
      try{ if(window.fbq) fbq('trackCustom','MonkSituacion',{situacion:id}); }catch(e){}
      try{ if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish) Shopify.analytics.publish('monk_situacion',{situacion:id,texto:texto||''}); }catch(e){}
    }
    function pintaCats(){
      cats.innerHTML=B.cats.map(function(c){return '<button type="button" role="tab" aria-selected="'+(c[0]===catAct)+'" data-cat="'+c[0]+'">'+c[1]+'</button>';}).join('');
      chips.innerHTML=B.casos.filter(function(x){return x.c===catAct;}).map(function(x){return '<button type="button" data-sit="'+x.id+'" aria-pressed="'+(actual===x.id)+'">'+x.p+'</button>';}).join('');
    }
    function plan(id,texto,callado){
      var x=B.casos.filter(function(c){return c.id===id;})[0]; if(!x) return; actual=id;
      if(x.c!==catAct){ catAct=x.c; }
      pintaCats();
      $('#sitT').textContent='«'+x.p+'»'; $('#sitD').textContent=x.d; $('#sitW').textContent=x.w; $('#sitR').textContent=x.r;
      $('#sitNo').innerHTML=x.no.map(app).join(''); $('#sitSi').innerHTML=x.si.map(app).join('');
      var qt=$('#sitQt'); if(x.q){ var rid=B.rid&&B.rid[x.q[1]]; qt.innerHTML='<span class="m3-estrellas" aria-hidden="true">★★★★★</span>«'+x.q[0]+'» '+(rid?'<a class="m3-verla" href="https://monktag.com/pages/reviews#resena='+rid+'" target="_blank" rel="noopener">'+x.q[1]+', compra verificada · ver reseña →</a>':'<i>'+x.q[1]+', compra verificada</i>'); qt.hidden=false; } else qt.hidden=true;
      $('#sitPk').innerHTML='Te recomendamos <b>'+B.packs[x.pk]+'</b>'+(x.pk>1?(x.pk==2?'. Uno para cada sitio o cada persona.':'. Uno para cada uno.'):'.');
      $('#sitBtn').setAttribute('data-pk',x.pk); $('#sitBtn').textContent='Lo quiero así · '+B.packs[x.pk].split(' · ')[0];
      $('#sitWa').href='https://wa.me/34688778244?text='+encodeURIComponent('Hola, mi caso con el móvil es: '+(texto||x.p));
      var pl=$('#sitPlan'); pl.classList.remove('m3-sit__plan--nuevo'); void pl.offsetWidth; pl.classList.add('m3-sit__plan--nuevo');
      if(!callado) avisa(id,texto);
    }
    function busca(t){
      var w=norm(t).split(/\s+/).filter(function(x){return x.length>2;}); if(!w.length) return [];
      return B.casos.map(function(c){ var h=norm(c.p+' '+c.k), n=0; w.forEach(function(x){ if(h.indexOf(x)>-1) n+=1; else if(x.length>4&&h.indexOf(x.slice(0,-1))>-1) n+=.6; }); return [n,c]; })
        .filter(function(r){return r[0]>0;}).sort(function(a,b){return b[0]-a[0];}).slice(0,4).map(function(r){return r[1];});
    }
    var tq; q.addEventListener('input',function(){ clearTimeout(tq); tq=setTimeout(function(){
      var r=busca(q.value);
      if(!q.value.trim()){ sug.hidden=true; return; }
      sug.innerHTML=(r.length?r.map(function(c){return '<li><button type="button" data-sit="'+c.id+'">'+c.p+'</button></li>';}).join(''):'')+
        '<li class="m3-sit__otro"><a href="https://wa.me/34688778244?text='+encodeURIComponent('Hola, mi caso con el móvil es: '+q.value)+'" target="_blank" rel="noopener">'+(r.length?'¿Es otra cosa? ':'Aún no lo tenemos. ')+'Cuéntanoslo por WhatsApp →</a></li>';
      sug.hidden=false;
    },120); });
    q.addEventListener('keydown',function(e){ if(e.key==='Enter'){ var r=busca(q.value); if(r[0]){ plan(r[0].id,q.value); sug.hidden=true; } e.preventDefault(); } });
    document.addEventListener('click',function(e){
      var c=e.target.closest('[data-cat]'); if(c&&cats.contains(c)){ catAct=c.getAttribute('data-cat'); pintaCats(); return; }
      var b=e.target.closest('[data-sit]'); if(b){ plan(b.getAttribute('data-sit'),sug.contains(b)?q.value:''); sug.hidden=true; }
      else if(!e.target.closest('.m3-sit__busca')) sug.hidden=true;
    });
    $('#sitBtn').addEventListener('click',function(){ radio($('#sitBtn').getAttribute('data-pk')); });
    plan('cama','',true); /* el plan de ejemplo no cuenta como dato */
  }

  /* --- contador: sube hasta la cifra real al verlo --- */
  $$('[data-cuenta]').forEach(function(el){
    var fin=+el.getAttribute('data-cuenta'), fmt=function(n){return Math.round(n).toLocaleString(EN()?'en-GB':'es-ES');};
    if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io=new IntersectionObserver(function(es){ if(!es[0].isIntersecting) return; io.disconnect();
      var t0=performance.now(), D=1600; (function f(t){ var k=Math.min(1,(t-t0)/D); el.textContent=fmt(fin*(1-Math.pow(1-k,3))); if(k<1) requestAnimationFrame(f); })(t0);
    },{threshold:.6}); io.observe(el);
  });

  /* --- cinta de reseñas: gira siempre, sin pausa al pasar el ratón y sin huecos --- */
  var cinta=$('.m3-cinta__pista');
  if(cinta&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
    var x=0, mitad=0, last=0, V=38; /* px por segundo */
    var mide=function(){ var ks=cinta.children, n=ks.length/2; if(!n) return; mitad=ks[n].offsetLeft-ks[0].offsetLeft; };
    mide(); addEventListener('resize',mide);
    if(document.fonts&&document.fonts.ready) document.fonts.ready.then(mide);
    (function paso(t){ if(last){ var dt=Math.min(.05,(t-last)/1000); x-=V*dt; if(mitad&&-x>=mitad) x+=mitad; cinta.style.transform='translate3d('+x+'px,0,0)'; } last=t; requestAnimationFrame(paso); })(0);
  }

  /* --- galería --- */
  var pista=$('#pista'), figs=$$('figure',pista), minis=$$('.m3-gal-minis button'), puntos=$$('.m3-gal-puntos i');
  var prev=$('.m3-gal-flecha--prev'), next=$('.m3-gal-flecha--next'), actual=0;
  function ir(i){ i=Math.max(0,Math.min(figs.length-1,i)); pista.scrollTo({left:pista.clientWidth*i,behavior:'smooth'}); }
  function marca(i){
    actual=i;
    /* precarga las dos siguientes para que nunca salgan en blanco */
    figs.slice(i,i+3).forEach(function(f){ var im=f.querySelector('img'); if(im&&im.loading==='lazy') im.loading='eager'; });
    minis.forEach(function(b,k){b.setAttribute('aria-selected',k===i?'true':'false');});
    puntos.forEach(function(p,k){p.classList.toggle('on',k===i);});
    if(prev) prev.disabled=i===0; if(next) next.disabled=i===figs.length-1;
  }
  minis.forEach(function(b,i){ b.addEventListener('click',function(){ir(i);}); });
  if(prev) prev.addEventListener('click',function(){ir(actual-1);});
  if(next) next.addEventListener('click',function(){ir(actual+1);});
  var tg; pista.addEventListener('scroll',function(){ clearTimeout(tg); tg=setTimeout(function(){ marca(Math.round(pista.scrollLeft/pista.clientWidth)); },50); },{passive:true});
  pista.addEventListener('keydown',function(e){ if(e.key==='ArrowRight'){ir(actual+1);e.preventDefault();} if(e.key==='ArrowLeft'){ir(actual-1);e.preventDefault();} });
  marca(0);
  /* vídeo de la galería: siempre en marcha, como un gif. Si el móvil bloquea la reproducción
     (ahorro de batería en iPhone), se cambia por la versión animada en imagen (gal-video.webp). */
  var gv=$('.m3-gal-vid video',pista);
  if(gv){
    var aGif=function(){ if(!gv.parentNode) return; var im=new Image(); im.src='https://cdn.shopify.com/s/files/1/0914/7485/4272/files/pdp3-v3-gal-video.webp'; im.width=720; im.height=720; im.alt=gv.getAttribute('aria-label'); im.decoding='async'; gv.parentNode.replaceChild(im,gv); };
    var dale=function(){ var p=gv.play(); if(p&&p.catch) p.catch(aGif); };
    gv.muted=true; dale();
    gv.addEventListener('pause',function(){ if(gv.isConnected&&!document.hidden) dale(); });
    document.addEventListener('visibilitychange',function(){ if(!document.hidden&&gv.isConnected) dale(); });
  }

  /* --- vídeos de clientes --- */
  var box=$('#vidbox'), vid=$('#vidboxV'), cap=$('#vidboxC'), ultimo=null;
  function abre(b){
    ultimo=b; vid.src=b.getAttribute('data-video'); pintaCap();
    box.hidden=false; document.documentElement.style.overflow='hidden';
    var p=vid.play(); if(p&&p.catch) p.catch(function(){}); $('.m3-vidbox__x').focus();
  }
  var DIC=null;
  function pintaCap(){ if(!ultimo) return; var q=ultimo.getAttribute('data-quote'), n=ultimo.getAttribute('data-name');
    if(EN()){ var k=q.replace(/\s+/g,' ').trim();
      if(DIC&&DIC[k]){ cap.textContent='"'+DIC[k]+'" · '+n; return; }
      if(!DIC&&window.MK_DICT_URL&&window.fetch){ fetch(window.MK_DICT_URL).then(function(r){return r.json();}).then(function(d){ DIC=d; pintaCap(); }).catch(function(){}); } }
    cap.textContent='«'+q+'» · '+n; }
  function cierra(){ vid.pause(); vid.removeAttribute('src'); vid.load(); box.hidden=true; document.documentElement.style.overflow=''; if(ultimo) ultimo.focus(); }
  document.addEventListener('click',function(e){ var b=e.target.closest('[data-video]'); if(b){ e.preventDefault(); abre(b); } });
  $('.m3-vidbox__x').addEventListener('click',cierra);
  box.addEventListener('click',function(e){ if(e.target===box) cierra(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!box.hidden) cierra(); });

  /* --- barra fija: aparece cuando el botón principal ya ha pasado hacia arriba --- */
  var barra=$('#barra'), b2=$('#boton2');
  if(barra&&'IntersectionObserver' in window){
    var finVisible=false, pasado=false;
    function pinta(){ var on=pasado&&!finVisible; barra.classList.toggle('on',on); barra.setAttribute('aria-hidden',on?'false':'true'); if(b2) b2.tabIndex=on?0:-1; }
    new IntersectionObserver(function(es){ var e=es[0]; pasado=!e.isIntersecting&&e.boundingClientRect.top<0; pinta(); }).observe(boton);
    var fin=$('#cierre'); if(fin) new IntersectionObserver(function(es){ finVisible=es[0].isIntersecting; pinta(); },{rootMargin:'0px 0px -20% 0px'}).observe(fin);
  }

  /* --- reseñas de Okendo en vivo (nota, total y % que recomienda) --- */
  var BASE='https://api.okendo.io/v1/stores/696156c8-1f74-4e8e-893f-325613be07dc/products/shopify-15144323088768';
  var OK=null;
  function pintaOk(){ var a=OK; if(!a) return; var en=EN();
    var media=(a.ratingAndReviewValuesTotal/a.ratingAndReviewCount).toFixed(1); if(!en) media=media.replace('.',',');
    $$('[data-ok="media"]').forEach(function(e){ if(e.textContent!==media) e.textContent=media; });
    $$('[data-ok="total"]').forEach(function(e){ var t=String(a.ratingAndReviewCount); if(e.textContent!==t) e.textContent=t; });
    var lv=a.ratingAndReviewCountByLevel||{};
    [1,2,3,4,5].forEach(function(n){ var c=lv['level'+n+'Count']||0;
      $$('[data-ok-c="'+n+'"]').forEach(function(e){ if(e.textContent!==String(c)) e.textContent=c; });
      $$('[data-ok-n="'+n+'"]').forEach(function(e){e.style.width=Math.round(100*c/a.ratingAndReviewCount)+'%';}); });
    $$('[data-ok="recom"]').forEach(function(e){ var t=Math.round(100*a.recommendationCount/a.ratingAndReviewCount)+(en?'%':' %'); if(e.textContent!==t) e.textContent=t; });
  }
  fetch(BASE+'/review_aggregate').then(function(r){return r.json();}).then(function(j){
    var a=j.reviewAggregate; if(!a||!a.ratingAndReviewCount) return;
    OK=a; pintaOk();
  }).catch(function(){});

  /* --- idioma: bloques con data-en y textos vivos se repintan al cambiar ES/EN --- */
  $$('[data-en]').forEach(function(e){ e.setAttribute('data-mk-partido',''); if(e.dataset.es===undefined) e.dataset.es=e.innerHTML; });
  var _lang=null;
  function pintaIdioma(){ var en=EN(); if(_lang===en) return; _lang=en;
    $$('[data-en]').forEach(function(e){ var h=en?e.getAttribute('data-en'):e.dataset.es; if(e.innerHTML!==h) e.innerHTML=h; });
    $$('[data-en-label]').forEach(function(e){ if(e.dataset.esLabel===undefined) e.dataset.esLabel=e.getAttribute('aria-label')||''; e.setAttribute('aria-label',en?e.getAttribute('data-en-label'):e.dataset.esLabel); });
    pintaFechas(); pintaOk(); pintaCap(); }
  pintaIdioma();
  if('MutationObserver' in window) new MutationObserver(pintaIdioma).observe(document.documentElement,{attributes:true,attributeFilter:['lang']});

  /* --- aparición suave. Reglas para que nunca desaparezca nada:
     1) solo se preparan elementos que están por debajo de la pantalla al cargar;
     2) se revelan antes de entrar (margen de 20 % por abajo);
     3) si el scroll los salta de golpe, se revelan igual;
     4) red de seguridad: a los 2,5 s de tocar cualquier scroll, todo lo que quede arriba se enseña. --- */
  if('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches){
    var sel='.m3-cab, .m3-ben, .m3-dos, .m3-capturas, .m3-pasos, .m3-pablo__txt, .m3-app__card, .m3-comp__pantallas, .m3-tabla, .m3-exp, .m3-garantia__foto, .m3-garantia__txt, .m3-faq__item, .m3-cierre__txt';
    var els=$$(sel,root).filter(function(e){ return e.getBoundingClientRect().top>innerHeight; });
    var ver=function(e){ e.classList.add('vis'); };
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting||e.boundingClientRect.top<innerHeight){ ver(e.target); io.unobserve(e.target);} });
    },{rootMargin:'0px 0px 20% 0px'});
    els.forEach(function(e,i){
      var hermanos=e.parentNode?[].indexOf.call(e.parentNode.children,e):0;
      e.style.transitionDelay=Math.min(hermanos,3)*70+'ms';
      e.classList.add('m3-r'); io.observe(e);
    });
    var red; addEventListener('scroll',function(){ clearTimeout(red); red=setTimeout(function(){ els.forEach(function(e){ if(e.getBoundingClientRect().top<innerHeight*1.2) ver(e); }); },400); },{passive:true});
  }
})();

/* Shopify (15 oct): «Ir a pagar» quita los Monks que hubiera en el carrito, añade el pack elegido y va al pago.
   Así cuenta como añadido al carrito. Si algo falla, sigue el enlace de siempre (/cart/ID:1). */
(function(){
  var pago=document.getElementById('cartPago'); if(!pago||!window.fetch) return;
  var VARS=[56125136470400,58484093256064,58484093288832], yendo=false;
  pago.addEventListener('click',function(e){
    var href=pago.getAttribute('href')||'', m=href.match(/\/cart\/(\d+):(\d+)/); if(!m||yendo) return;
    e.preventDefault(); yendo=true; pago.setAttribute('aria-busy','true');
    var up={}; VARS.forEach(function(v){up[v]=0;});
    var J={'Content-Type':'application/json','Accept':'application/json'};
    fetch('/cart/update.js',{method:'POST',headers:J,body:JSON.stringify({updates:up})})
      .then(function(){ return fetch('/cart/add.js',{method:'POST',headers:J,body:JSON.stringify({items:[{id:+m[1],quantity:+m[2]}]})}); })
      .then(function(r){ if(!r.ok) throw 0; location.href='/checkout'; })
      .catch(function(){ location.href=href; });
  });
})();
